import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LightStateNode {
    id: number;
    name: string;
    nodeId: number;
    position: {
        x: number;
        y: number;
        z: number;
    };
    isOn: boolean;
    color: string;
    pinMarkerItemId?: string; // ID của Pin Marker item
    objectId?: string; // Object ID để tìm pinMarkerItem
}

export interface LightStatesState {
    nodes: LightStateNode[];
    isFetching: boolean;
}

const initialState: LightStatesState = {
    nodes: [],
    isFetching: false,
};

const lightStatesSlice = createSlice({
    name: "lightStates",
    initialState,
    reducers: {
        setLightStatesNodes: (
            state,
            action: PayloadAction<LightStateNode[]>
        ) => {
            state.nodes = action.payload;
        },
        toggleLightState: (state, action: PayloadAction<number>) => {
            const node = state.nodes.find((n) => n.nodeId === action.payload);
            if (node) {
                node.isOn = !node.isOn;
            }
        },
        setLightStateOn: (
            state,
            action: PayloadAction<{ nodeId: number; isOn: boolean }>
        ) => {
            const node = state.nodes.find(
                (n) => n.nodeId === action.payload.nodeId
            );
            if (node) {
                node.isOn = action.payload.isOn;
            }
        },
        setFetching: (state, action: PayloadAction<boolean>) => {
            state.isFetching = action.payload;
        },
        addLightStateNode: (state, action: PayloadAction<LightStateNode>) => {
            state.nodes.push(action.payload);
        },
        removeLightStateNode: (state, action: PayloadAction<number>) => {
            state.nodes = state.nodes.filter(
                (n) => n.nodeId !== action.payload
            );
        },
    },
});

export const {
    setLightStatesNodes,
    toggleLightState,
    setLightStateOn,
    setFetching,
    addLightStateNode,
    removeLightStateNode,
} = lightStatesSlice.actions;

export default lightStatesSlice.reducer;
